<script setup lang="ts">
const props = defineProps({
  icon: { type: String, required: true },
  size: { type: String, default: "default" }, // x-small | small | default | large | x-large
  iconSize: { type: [String, Number], default: 24 },
  color: { type: String, default: "primary" },
  variant: { type: String, default: "plain" }, // puoi passarla dal parent se vuoi
  ariaLabel: { type: String, required: true },

  // nuove/aggiornate
  isIcon: { type: Boolean, default: true }, // <<— rende il v-btn icon-only quando true
  showLabel: { type: Boolean, default: false },
  label: { type: String, default: "" },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(["click"]);

// icon-only solo se esplicitamente richiesto e se non mostri label
const isIconOnly = computed(() => props.isIcon && !(props.showLabel && props.label));
</script>

<template>
  <v-btn
    :variant="variant as any"
    :ripple="false"
    :size="size"
    :color="color"
    :aria-label="ariaLabel"
    :icon="isIconOnly"
    class="text-none"
    :loading="loading"
    @click="emit('click', $event)"
  >
    <Iconify :icon="icon" :height="iconSize" />
    <span v-if="!isIconOnly && showLabel" class="ml-2">{{ label }}</span>
  </v-btn>
</template>
